import { Check, Warning } from '@phosphor-icons/react';

import { Slider } from '../ui/Slider';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

const FALLBACK_COLORS = ['#7C9E6F', '#C9A46B', '#7C93A8', '#4F6879', '#8A6D3B', '#78716C'];

/**
 * Sliders to allocate percentages across budget method groups (must sum to 100).
 */
export function MethodPercentageSliders({
  groups,
  percentages,
  onPercentageChange,
  total,
  isValid,
  className,
}) {
  return (
    <div className={cn('flex flex-col gap-space-4', className)}>
      {groups.map((group, index) => (
        <div key={group.name || index} className="flex flex-col gap-space-2">
          <div className="type-body-sm flex items-center justify-between">
            <div className="flex items-center gap-space-2">
              <span
                className="h-2.5 w-2.5 shrink-0 rounded-ds-sm"
                style={{
                  backgroundColor:
                    group.color || FALLBACK_COLORS[index % FALLBACK_COLORS.length],
                }}
                aria-hidden
              />
              <span className="font-medium text-foreground">{group.name}</span>
            </div>
            <span className="font-numeric tnum text-muted-foreground">
              {Number(percentages[index] ?? 0).toFixed(0)}%
            </span>
          </div>
          <Slider
            min={0}
            max={100}
            step={5}
            value={[percentages[index] ?? 0]}
            onValueChange={(value) => onPercentageChange(index, value)}
            aria-label={group.name}
          />
        </div>
      ))}

      <div
        className={cn(
          'flex items-center justify-between gap-space-2 rounded-ds-md border px-space-3 py-space-2',
          isValid
            ? 'border-success-500/30 bg-success-50 text-success-700 dark:border-success-500/40 dark:bg-success-950/30 dark:text-success-300'
            : 'border-warning-500/40 bg-warning-50 text-warning-700 dark:border-warning-500/40 dark:bg-warning-950/30 dark:text-warning-300',
        )}
      >
        <span className="type-body-sm flex items-center gap-space-2 font-medium">
          {isValid ? (
            <Check className="h-3.5 w-3.5" aria-hidden />
          ) : (
            <Warning className="h-3.5 w-3.5" aria-hidden />
          )}
          {pt.onboarding.method.customise.total}: {total}%
        </span>
        <span className="type-chip">
          {isValid
            ? pt.onboarding.method.customise.totalGood
            : pt.onboarding.method.customise.totalBad}
        </span>
      </div>
    </div>
  );
}
